import React from "react";
import { KBarResults, useMatches } from "kbar";
import { ArrowRightIcon } from "@heroicons/react/solid";
const groupNameStyle = {
    fontSize: "14px",
    color: "#333",
};

function formatName(name) {
    const meta = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)
        ? "\u2318"
        : "Ctrl";

    return name.replace(/(meta)/i, meta);
}

export default function SearchResults(props) {
    const { results } = useMatches();

    return (
        <KBarResults
            items={results}
            onRender={({ item, active }) =>
                typeof item === "string" ? (
                    <div>{item}</div>
                ) : (
                    <div
                        style={Object.assign({}, groupNameStyle, {
                            padding: active ? "8px 16px 8px 13px" : "8px 16px",
                            background: active ? "#eee" : "transparent",
                            borderLeft: active ? "3px solid #059669" : "none",
                        })}
                    >
                        <div className="flex">
                            <div className="flex-grow">
                                {item.name}{" "}
                                {item.children.length > 0 && (
                                    <ArrowRightIcon className="inline h-3 w-3" />
                                )}
                            </div>
                            {item.shortcut && item.shortcut.length && (
                                <div className="flex-shrink-0 text-center text-sm tracking-tighter text-green-700">
                                    {formatName(item.shortcut.join(" then "))}
                                </div>
                            )}
                        </div>
                    </div>
                )
            }
        />
    );
}
